import { useState } from "react";
export const VALUE_DELIMITER = "";
const useChipInput = ({
  values,
  onChange,
  normalize,
  validate,
  validateInput,
  max,
  describeInvalid,
  describeDuplicate,
  suppressCreate,
  onInputChanged
}) => {
  const [input, setInput] = useState("");
  const [duplicateAttempt, setDuplicateAttempt] = useState(null);
  const candidate = normalize(input);
  const isAtMax = values.length >= max;
  const inputMessage = candidate ? (validateInput != null ? validateInput : validate)(candidate, input) : null;
  const handleChange = (joined, actionMeta) => {
    const raw = joined ? joined.split(VALUE_DELIMITER) : [];
    const normalized = raw.map(normalize).filter((value) => value.length > 0);
    onChange(Array.from(new Set(normalized)).slice(0, max));
    if ((actionMeta == null ? void 0 : actionMeta.action) !== "remove-value" && (actionMeta == null ? void 0 : actionMeta.action) !== "pop-value") {
      setInput("");
      onInputChanged == null ? void 0 : onInputChanged("");
    }
    setDuplicateAttempt(null);
  };
  const handleInputChange = (value, actionMeta) => {
    if ((actionMeta == null ? void 0 : actionMeta.action) !== "input-change") return;
    setInput(value);
    onInputChanged == null ? void 0 : onInputChanged(value);
    setDuplicateAttempt(null);
  };
  const flagDuplicateAttempt = () => {
    if (candidate && values.includes(candidate)) {
      setDuplicateAttempt(candidate);
    }
  };
  const isValidNewOption = (raw) => {
    const value = normalize(raw != null ? raw : "");
    return value.length > 0 && validate(value) === null && !isAtMax && // Replaces react-select's own duplicate check, which this overrides.
    !values.includes(value) && !(suppressCreate == null ? void 0 : suppressCreate(raw, value));
  };
  const invalidValues = values.filter((value) => validate(value) !== null);
  const messages = [
    describeInvalid(invalidValues),
    inputMessage,
    duplicateAttempt ? describeDuplicate(duplicateAttempt) : null
  ].filter((message) => !!message);
  return {
    input,
    candidate,
    isAtMax,
    messages,
    setDuplicateAttempt,
    flagDuplicateAttempt,
    /** Spread onto `Select`. */
    selectProps: {
      delimiter: VALUE_DELIMITER,
      value: values.join(VALUE_DELIMITER),
      inputValue: input,
      onChange: handleChange,
      onInputChange: handleInputChange,
      onBlur: flagDuplicateAttempt
    },
    /** Spread onto `Select` too; cast because its Props type doesn't surface these. */
    reactSelectProps: {
      isValidNewOption,
      // An open menu covers the message saying why the value was rejected.
      menuIsOpen: inputMessage ? false : void 0
    }
  };
};
export default useChipInput;
